var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteMonitoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9 9C9 8.58579 9.33579 8.25 9.75 8.25C10.1642 8.25 10.5 8.58579 10.5 9V12C10.5 12.4142 10.1642 12.75 9.75 12.75C9.33579 12.75 9 12.4142 9 12V9ZM5.25 10.5C5.25 10.0858 5.58579 9.75 6 9.75C6.41421 9.75 6.75 10.0858 6.75 10.5V12C6.75 12.4142 6.41421 12.75 6 12.75C5.58579 12.75 5.25 12.4142 5.25 12V10.5ZM1.5 6C1.5 5.58579 1.83579 5.25 2.25 5.25C2.66421 5.25 3 5.58579 3 6V12C3 12.4142 2.66421 12.75 2.25 12.75C1.83579 12.75 1.5 12.4142 1.5 12V6Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9698 21.9697C22.2626 21.6769 22.2626 21.2021 21.9698 20.9093L17.4831 16.4226C17.1169 16.0563 17.0969 15.4742 17.3831 15.0424C18.2721 13.7014 18.7513 12.1223 18.75 10.5C18.75 5.95125 15.0488 2.25 10.5 2.25C8.94949 2.25 7.46612 2.6719 6.16693 3.47749C5.81549 3.69542 5.75028 4.16801 5.99839 4.49882C6.2472 4.83056 6.71637 4.89304 7.07328 4.68194C8.10675 4.07069 9.29011 3.74634 10.5 3.75C14.2223 3.75 17.25 6.77775 17.25 10.5C17.25 14.2222 14.2223 17.25 10.5 17.25C9.45142 17.254 8.41652 17.0118 7.47862 16.5428C6.76609 16.1866 6.12465 15.707 5.58307 15.1282C5.29899 14.8246 4.82974 14.7531 4.49733 15.0028C4.16702 15.2509 4.09698 15.7221 4.37284 16.0296C5.05891 16.7944 5.88438 17.425 6.80742 17.8863C7.95374 18.4592 9.21853 18.7551 10.5 18.75C12.1775 18.75 13.7395 18.2459 15.0432 17.3817C15.4745 17.0958 16.0558 17.1163 16.4217 17.4821L20.9093 21.9697C21.2021 22.2626 21.6769 22.2626 21.9698 21.9697Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteMonitoring);
export default __webpack_public_path__ + "static/media/WhiteMonitoring.322fa7a44006364bcc99f458f0974530.svg";
export { ForwardRef as ReactComponent };